export default "__VITE_ASSET__ic85djW___"